import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Desktop Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M224.492 12.21H31.508C15.52 12.207 2.56 25.168 2.56 41.156v135.09c0 15.987 12.96 28.948 28.948 28.947h86.843v19.298H89.403c-7.428 0-12.07 8.042-8.356 14.475a9.65 9.65 0 0 0 8.356 4.824h77.194c7.428 0 12.07-8.042 8.356-14.475a9.65 9.65 0 0 0-8.356-4.824h-28.948v-19.298h86.843c15.988 0 28.948-12.96 28.948-28.948V41.156c0-15.986-12.96-28.947-28.948-28.947M31.508 31.507h192.984a9.65 9.65 0 0 1 9.65 9.649v96.492H21.859V41.157a9.65 9.65 0 0 1 9.649-9.65m192.984 154.387H31.508c-5.33 0-9.65-4.32-9.65-9.649v-19.298h212.283v19.298c0 5.33-4.32 9.65-9.649 9.65" }, null, -1)
  ])))
}
export default { render: render }